<template>
  <div class="w-full md:w-full h-full flex items-center relative">
    <span class="px-3 absolute pt-1">
      <feather-icon icon="DollarSignIcon" svgClasses="w-5 h-5" />
    </span>
    <input
      autocomplete="off"
      :value="answer"
      @keyup="sendAnswer($event)"
      id="inputNumber"
      ref="inputNumber"
      style="font-size: 16px"
      class="h-full border w-full px-2 py-2 bg-transparent rounded-lg text-center font-family"
      type="text"
    />
  </div>
</template>

<script>
import mixins from "./mixinsNumberCurrency";
export default {
  mixins: [mixins],
  props: {
    value: {
      type: String | Number,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    }
  },
  methods: {
    sendAnswer(e) {
      if (this.validateKeyBoards(e.key)) {
        const dato = this.answer + e.key;
        e.target.value = this.formaterCurrency(dato);
        this.answer = this.removeFormatter(e.target.value);
      } else {
        e.target.value = this.formaterCurrency(e.target.value);
        this.answer = this.removeFormatter(e.target.value);
      }
    }
  },
  computed: {
    answer: {
      get() {
        return this.formaterCurrency(String(this.value));
      },
      set(value) {
        if (isNaN(value)) return this.$emit("input", "");
        this.change(value, this.Item);
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}
</style>
